export * from './number-selector.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/number-selector/index.ts